import { HintErrorComponent } from './hint-error';
export * from './hint-error';
HintErrorComponent.define();
